export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/7f8fea9003e1a4e1e0e93817290b5b81.png";